/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

/**
 * Bootstrap the application using modern standalone approach
 */
bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    console.log('✅ Basilisk Booking System started successfully');
  })
  .catch(err => {
    console.error('❌ Error bootstrapping application:', err);
  });
